import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AppEntry from "./pages";
import { msalInit } from "./authorization/AuthorizationProvider";
import { store } from "./store";
import "./styles/main.scss";
import { Provider } from "react-redux";

// Wait for handleRedirectPromise() inside msalInit — otherwise the first paint has no account,
// UnauthenticatedTemplate shows Login, and Login fires loginRedirect again (loop).
msalInit.then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById("proscan-root") as HTMLElement
  );

  root.render(
    <BrowserRouter>
      <Provider store={store}>
        <AppEntry />
      </Provider>
    </BrowserRouter>
  );
});
